import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { extendedTestimonials, stats, testimonials } from '../data/offer';
function Stars() {
  return <div className="flex gap-1 text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-173" data-mp="3gqhw3medjbas">
      {[1, 2, 3, 4, 5].map(item => <StarIcon key={item} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-174" data-mp="3brdkyq7w33ht" />)}
    </div>;
}
export function StatsAndProof() {
  return <>
      <section className="border-y border-brand-green/20 bg-brand-ink px-4 py-14 sm:py-20" data-id="element-175" data-mp="3qmkvwllr6xuk">
        <div className="mx-auto max-w-4xl" data-id="element-176" data-mp="3lo067g44nwkd">
          <h2 className="text-center font-display text-xl font-bold tracking-[.14em] text-brand-light sm:text-2xl" data-id="element-177" data-mp="3c3d11hbj424">
            📊 MADRES YA ORGANIZADAS
          </h2>
          <div className="mt-10 grid grid-cols-2 gap-x-5 gap-y-10 sm:grid-cols-4" data-id="element-178" data-mp="da10hmrcswto">
            {stats.map(([value, label]) => <div key={label} className="text-center" data-id="element-179" data-mp="8bprfe8vuqci">
                <p className="font-display text-4xl font-bold sm:text-5xl" data-id="element-180" data-mp="893jvelzsaua">{value}</p>
                <p className="mt-2 text-xs font-semibold leading-tight text-brand-light sm:text-sm" data-id="element-181" data-mp="1gez7jiy3yj4e">
                  {label}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="bg-brand-dark px-4 py-16 sm:py-20" data-id="element-182" data-mp="1ucnseqs6dq9g">
        <div className="mx-auto max-w-6xl" data-id="element-183" data-mp="1udyvsphpkw01">
          <h2 className="text-center font-display text-2xl font-bold sm:text-3xl" data-id="element-184" data-mp="1zc0ayzc0kb68">
            💬 Lo que dicen las madres
          </h2>
          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-185" data-mp="249io71x2dck1">
            {testimonials.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: Math.min(index * 0.05, 0.15),
            duration: 0.3,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-2xl border border-white/10 bg-brand-ink p-6" data-id="element-186" data-mp="2e0n0ftvcujb6" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-187" data-mp="wov6pbc2fjwp">
                  <div className="grid h-11 w-11 shrink-0 place-items-center rounded-full border border-brand-green/40 font-bold text-brand-light" data-id="element-188" data-mp="wqg1n22al4v3">
                    {initials}
                  </div>
                  <div data-id="element-189" data-mp="16lhry18b0cz9">
                    <h3 className="font-bold" data-id="element-190" data-mp="16ovtx8d22k66">{name}</h3>
                    <p className="text-sm text-slate-400" data-id="element-191" data-mp="11mws42wyrvbc">{place}</p>
                  </div>
                </div>
                <div className="mt-5" data-id="element-192" data-mp="1fn7ht2mjf3ux">
                  <Stars data-id="element-193" data-mp="1aomrpw1020k7" />
                </div>
                <p className="mt-4 italic leading-relaxed text-slate-300" data-id="element-194" data-mp="1apxw9y29rccd">“{quote}”</p>
              </motion.article>)}
          </div>
        </div>
      </section>
    </>;
}
export function ExtendedTestimonials() {
  return <section className="border-y border-white/10 bg-brand-dark px-4 py-14 sm:py-20" data-id="element-195" data-mp="3cidnsiuj10ij">
      <div className="mx-auto max-w-5xl" data-id="element-196" data-mp="1ryqleo36yos2">
        <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-197" data-mp="1wxl5rugt4lea">
          💬 LO QUE DICEN LAS MADRES QUE YA LO USAN
        </h2>
        <div className="grid gap-7 md:grid-cols-2" data-id="element-198" data-mp="1j3u5lcoyudv8">
          {extendedTestimonials.map(([name, place, quote]) => <article key={name} className="border-l-2 border-brand-green pl-4" data-id="element-199" data-mp="197qu3g8852vm">
              <Stars data-id="element-200" data-mp="199trwmfmc0aw" />
              <p className="mt-2 font-bold" data-id="element-201" data-mp="1e6aehc7666lv">
                {name} <span className="font-normal text-slate-400" data-id="element-202" data-mp="1e7vbr9kvc3nf">· {place}</span>
              </p>
              <p className="mt-2 text-sm italic leading-relaxed text-slate-300" data-id="element-203" data-mp="108dleprxciby">{quote}</p>
            </article>)}
        </div>
      </div>
    </section>;
}